"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReCaptchaLoader_1 = require("./ReCaptchaLoader");
exports.load = ReCaptchaLoader_1.load;
exports.getInstance = ReCaptchaLoader_1.getInstance;
var ReCaptchaInstance_1 = require("./ReCaptchaInstance");
exports.ReCaptchaInstance = ReCaptchaInstance_1.ReCaptchaInstance;



//////////////////
// WEBPACK FOOTER
// /home/giant/builds/t1_QpaSbS/1/vivesa/imcopharma.com/node_modules/recaptcha-v3/dist/ReCaptcha.js
// module id = 73
// module chunks = 0